import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const token = localStorage.getItem("stock_token");
    if (!token) {
      setLoading(false);
      return;
    }
    // Show cached user immediately so refreshes never flash a logout
    const cached = localStorage.getItem("stock_user");
    if (cached) {
      try {
        setUser(JSON.parse(cached));
      } catch {
        localStorage.removeItem("stock_user");
      }
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("stock_user", JSON.stringify(data));
    } catch (err) {
      // Only log out when the token is actually invalid/expired (401/403).
      // Transient network / gateway errors must NOT wipe the session.
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem("stock_token");
        localStorage.removeItem("stock_user");
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("stock_token", data.token);
    localStorage.setItem("stock_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("stock_token", data.token);
    localStorage.setItem("stock_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("stock_token");
    localStorage.removeItem("stock_user");
    // Best-effort revoke server session cookie
    api.post("/auth/logout").catch(() => {});
    setUser(null);
  };

  const setUserFromGoogle = (u) => {
    setUser(u);
    localStorage.setItem("stock_user", JSON.stringify(u));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUserFromGoogle }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
